/* global axios */
import ApiClient from './ApiClient';

class ClusterMembershipsAPI extends ApiClient {
  constructor() {
    super('clusters', { accountScoped: true });
  }

  get(clusterId) {
    return axios.get(`${this.url}/${clusterId}/memberships`);
  }

  create(clusterId, membership) {
    return axios.post(`${this.url}/${clusterId}/memberships`, { membership });
  }

  update(clusterId, id, membership) {
    return axios.patch(`${this.url}/${clusterId}/memberships/${id}`, { membership });
  }

  delete(clusterId, id) {
    return axios.delete(`${this.url}/${clusterId}/memberships/${id}`);
  }
}

export default new ClusterMembershipsAPI();
